var _circle, _ellipse, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 109,
    viewBox: "0 0 108 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54.5,
    r: 53.5,
    stroke: "url(#paint0_linear_8020_812008)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54,
    cy: 54.5,
    rx: 40,
    ry: 40,
    fill: "url(#paint1_linear_8020_812008)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8020_812008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1437 71.5L33 56.6769L35.0484 54.4503L46.1437 67.0467L71.0085 39.5L73 41.7903L46.1437 71.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8020_812008",
    x1: 134.663,
    y1: 0.500003,
    x2: -66.4727,
    y2: 39.6976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CD0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499976,
    stopColor: "#2178C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8020_812008",
    x1: 113.75,
    y1: 14.5,
    x2: -35.2391,
    y2: 43.5353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CD0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499976,
    stopColor: "#2178C0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8020_812008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 30,
    fill: "white",
    transform: "translate(33 39.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.f10b19e8314f33a59d04fd78d19937f7.svg";
export { ForwardRef as ReactComponent };